import { render, staticRenderFns } from "./getToken.vue?vue&type=template&id=ec92309a"
import script from "./getToken.vue?vue&type=script&lang=ts"
export * from "./getToken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports